import { BorderRadius, Color, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const CustomTooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${Spacing.S8};
  padding: ${Spacing.S16} ${Spacing.S24};
  border-radius: ${BorderRadius.R8};
  background: ${Color.Black};
  box-shadow: ${getShadow('raisedLight')};
  color: ${Color.White};
`

export const CustomTooltipTitle = styled.div`
  height: 26px;
`
